// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3aQSL","content":"styles_content__3lQhb"};